import { createAction, props } from '@ngrx/store';
import { ExhibitionDto } from '@api/rest';

export const loadExhibitions = createAction(
  '[Exhibition/API] Load Exhibitions'
);

export const loadExhibitionsSuccess = createAction(
  '[Exhibition/API] Load Exhibitions Success',
  props<{ exhibitions: ExhibitionDto[] }>()
);

export const loadExhibitionsFailure = createAction(
  '[Exhibition/API] Load Exhibitions Failure',
  props<{ error: any }>()
);

export const getExhibition = createAction(
  '[Exhibition/API] Get Exhibition',
  props<{ id: string }>()
);

export const getExhibitionSuccess = createAction(
  '[Exhibition/API] get Exhibition Success',
  props<{ exhibition: ExhibitionDto }>()
);

export const getExhibitionFailure = createAction(
  '[Exhibition/API] Get Exhibition Failure',
  props<{ error: any }>()
);

export const setSelectedExhibition = createAction(
  '[Exhibition/API] Get Selected Exhibition',
  props<{ id: string }>()
);
